import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% / 4);
  height: 186px;
  padding: 24px 24px 48px 24px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid var(--neutral-colors-cinza-300, #b1b3b3);

  .icon {
    margin-bottom: 10px;
  }

  .text {
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    margin-bottom: 4px;
    display: block;
    color: #4d4d4d;
  }

  .container-value-help {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .value {
      font-size: 18px;
      font-weight: 700;
      line-height: 28px;
      color: ${({ color }) => color};
    }
  }

  @media (max-width: 1000px) {
    width: 100%;
    height: auto;
    min-height: fit-content;
    padding: 16px;

    .icon {
      margin-bottom: 4px;
      svg {
        width: 20px;
        height: 20px;
      }
    }

    .text {
      font-size: 14px;
      line-height: 20px;
    }

    .container-value-help {
      .value {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;
